import { useEffect, useState, useState } from "react";
import { listenDb, offListenDb } from "@/js/firebase";
import { getUrlParam } from "@/js/functions";
import map from "lodash/map";

const useAttachedImage = (activeSessionObj: any) => {
  const [showBtn, setshowBtn] = useState();
  const [attachedImageStates, setattachedImageStates] = useState({});
  const [currentAttachedImage, setcurrentAttachedImage] = useState("");

  // リッスンして、画像を先読み
  useEffect(() => {
    if (activeSessionObj?.id && activeSessionObj?.status !== 0) {
      const path = `${getUrlParam(0)}/showAttachedImage/${getUrlParam(1)}/${
        activeSessionObj.id
      }`;

      listenDb(path, (data) => {
        setattachedImageStates(data);
        // 画像を先読み
        // map(data, (value, key) => {
        //   preloadImage(value.imgPath);
        // });
      });

      if (activeSessionObj?.showAttachedImageBtn) {
        setshowBtn(true);
      } else {
        setshowBtn(false);
      }

      const attachmentImagePath = `${getUrlParam(
        0
      )}/attachmentImage/${getUrlParam(1)}/${activeSessionObj.id}`;
      listenDb(attachmentImagePath, (data) => {
        setcurrentAttachedImage(data);
      });

      // offlistenすると他のコンポーネント（今回はregisterUser用の同じコンポーネント）に影響が出るのでしない
    }
  }, [activeSessionObj]);

  return { showBtn, setshowBtn, currentAttachedImage, attachedImageStates };
};

function preloadImage(path, callback) {
  const img = new Image();

  if (callback) {
    img.onload = callback;
  }
  img.src = `${location.origin}${path}`;
}

export default useAttachedImage;
